module.exports = __webpack_public_path__ + "img/task_add_plus_small.315ee0b8.svg";